import React from 'react';
import LoadingSpinner from '../Generic/LoadingSpinner';
import { CloudDownload as DownloadIcon } from '../Generic/Icons';
import XMLView from '../XMLView';
import HTMLDocxLink from '../Generic/HTMLDocxLink';
import { useCVGeneration } from '../../Hooks/useCVGeneration';

export function CVDisplay({ formData: _formData, setCVBytes, template, loading }) {
    const [formData, setFormData] = React.useState(_formData);
    // adding a bit delay to ensure that we are not rendering for every minor changes.
    React.useEffect(() => {
        if (_formData !== formData) {
            if (!formData) {
                setFormData(_formData);
            } else {
                let mounted = true;
                setTimeout(() => {
                    if (mounted) setFormData(_formData);
                }, 678);
                return () => { mounted = false; };
            }
        }
    }, [_formData, formData]);

    const { xmlViewProps, cvData } = useCVGeneration({ setCVBytes, formData, template });

    if (loading || !formData.cvDOCX) return <LoadingSpinner>Loading CV...</LoadingSpinner>;
    else if (xmlViewProps.current?.XML
        && ['numbering.xml', 'main.xml'].every(key => Object.keys(xmlViewProps.current.XML).includes(key)
        )) return (
            <>
                <div className="d-flex flex-grow-1 justify-content-end" style={{ maxHeight: "2.7rem" }}>
                    <button
                        type="button"
                        className='btn btn-primary me-2 rounded-pill'
                        onClick={() => {
                            const blob = new Blob([formData.cvDOCX], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                            const cvUrl = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = cvUrl;
                            a.download = cvData.mcb_cvname || `CV_${formData.mcb_roletitle}.docx`;
                            a.style.display = "none";
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(cvUrl);
                        }}
                        
                    ><DownloadIcon className="icon" /> Download Draft CV</button>
                
                    <HTMLDocxLink rounded HTML={cvData.mcb_coverletter} name={`CoverLetter_${ cvData.mcb_cvname || formData.mcb_roletitle}`}>
                        Download Draft Cover Letter
                    </HTMLDocxLink>
                </div>
                <div className="w-100 xml-view-container">
                <XMLView watermark={(<>Preview Only!<br/>Please download to review content and format.</>)} {...xmlViewProps.current} loading={xmlViewProps.current.loading || xmlViewProps.current.template !== template} />
                </div>
            </>
        ); else return <></>;
}
